window.chTypeAhead = (function ($, Bloodhound, _, urlHelper) {
    var engines = (function () {
        var cache = {};

        var sort = {
            Active: function (a, b) { return a.Active == b.Active ? sort.label(a, b) : b.Active - a.Active; },
            active: function (a, b) { return a.active == b.active ? sort.label(a, b) : b.active - a.active; },
            archived: function (a, b) { return a.archived == b.archived ? sort.label(a, b) : a.archived - b.archived; },
            label: function (a, b) { return a.label < b.label ? -1 : (a.label > b.label ? 1 : 0); },
            relevance: function (a, b) { return b.relevance - a.relevance; }
        };

        var ignore = {
            Deactivated: function (d) { return d.Active === false; },
            deactivated: function (d) { return d.active === false; },
            archived: function (d) { return d.archived === true; }
        };

        function get(type) {
            if (!cache.hasOwnProperty(type)) {
                cache[type] = new Bloodhound(getConfig(type));
            }
            return cache[type];
        }

        function getConfig(type) {
            switch (type) {
                case 'Organisation':
                    return buildConfig({
                        url: '/admin/suggest/organisation?s={s}&maxResults=20',
                        value: 'Id',
                        label: function (datum) { return datum.Name + delimit(' - ', datum.Division); },
                        ignore: ignore.Deactivated
                    });
                case 'OrganisationContact':
                    return buildConfig({
                        url: '/admin/suggest/organisationContact?s={s}&active=true',
                        value: 'Id',
                        label: function (datum) { return datum.FirstName + delimit(', ' , datum.LastName); },
                        ignore: ignore.Deactivated
                    });
                case 'Activity':
                    return buildConfig({
                        url: '/admin/activities/search/suggest?text={s}&take=20',
                        value: 'id',
                        label: 'title'
                    });
                case 'ActivityType':
                    return buildConfig({
                        url: '/admin/suggest/' + type,
                        prefetch: { key: type, sort: sort.label },
                        ignore: ignore.archived
                    });
                case 'Administrator':
                    return buildConfig({
                        url: '/admin/suggest/administrator?maxResults=9000',
                        prefetch: { key: type, sort: sort.Active },
                        value: 'Id',
                        label: 'Name',
                        tokens: ['Position'],
                        ignore: ignore.Deactivated
                    });
                case 'JounralLabel':
                case 'GeneralLabel':
                    return buildConfig({
                        url: '/admin/suggest/label?type=' + type.substring(0, 7),
                        prefetch: { key: type, sort: sort.archived },
                        ignore: ignore.archived
                    });
                case 'JobSeeker':
                    return buildConfig({
                        url: '/admin/suggest/jobseeker/suggest?s={s}&maxResults=20',
                        value: 'Id',
                        label: function (datum) { return datum.FirstName + ' ' + datum.LastName; }
                    });
                case 'Campus':
                    return buildConfig({
                        url: '/admin/suggest/' + type,
                        prefetch: { key: type, sort: sort.label },
                        ignore: ignore.archived
                    });
                case 'CampusBuilding':
                    return buildConfig({
                        url: '/admin/suggest/' + type,
                        prefetch: { key: type, sort: sort.label },
                        ignore: ignore.archived
                    });
                case 'OnCampusLocation':
                    return buildConfig({
                        url: '/admin/suggest/' + type,
                        prefetch: { key: type, sort: sort.label },
                        ignore: ignore.archived
                    });
                case 'Developer':
                    return buildConfig({
                        url: '/admin/suggest/developers',
                        value: 'Id',
                        prefetch: { key: type, sort: sort.label },
                        label: function (datum) { return datum.Name + delimit(' - ', datum.Company); }
                    });
                case 'ExperienceType':
                    return buildConfig({
                        url: '/admin/suggest/category?key=' + type,
                        prefetch: { key: type, sort: sort.active },
                        ignore: ignore.deactivated
                    });
                case 'Event':
                    return buildConfig({
                        url: '/admin/suggest/event?s={s}&maxResults=20',
                        value: 'Id',
                        label: 'Title'
                    });
                case 'Country':
                    return buildConfig({
                        url: '/countries',
                        value: 'code',
                        label: 'name',
                        tokens: ['code', 'alpha3', 'aliases'],
                        prefetch: { key: type, sort: sort.relevance, cache: true }
                    });
                case 'EventType':
                    return buildConfig({
                        url: '/admin/suggest/' + type,
                        prefetch: { key: type, sort: sort.label },
                        ignore: ignore.archived
                    });
                case 'Skill':
                    return buildConfig({
                        url: '/admin/suggest/skill',
                        prefetch: { key: type, sort: sort.label },
                        ignore: ignore.archived
                    });
                case 'WorkGroup':
                    return buildConfig({
                        url: '/admin/suggest/' + type,
                        prefetch: { key: type }
                    });
                case 'Major':
                    return buildConfig({
                        url: '/admin/suggest/major?s={s}&maxResults=20',
                        value: 'value',
                        label: 'value'
                    });
                case 'ResourceTopic':
                    return buildConfig({
                        url: '/admin/suggest/resourcetopic?s={s}'
                    });
                case 'GuestTracker':
                    return buildConfig({
                        url: '/admin/suggest/guestTracker?s={s}&Active=true',
                        value: 'EntityId',
                        label: function (datum) { return datum.FirstName + delimit(', ', datum.LastName); },
                        ignore: ignore.Deactivated
                    });
                case 'Endorsement':
                    return buildConfig({
                        url: '/admin/suggest/endorsements?s={s}',
                        value: 'id',
                        label: 'name',
                        ignore: ignore.archived
                    });
                default:
                    throw "'" + type + "' type not supported";
            }
        }

        function buildConfig(config) {
            if (!config.value) config.value = 'id';
            if (!config.label) config.label = 'name';
            
            var opts = {
                initialize: false,
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                datumTokenizer: function (datum) {
                    var tokens = [];

                    if (config.ignore && config.ignore(datum)) {
                        return tokens;
                    }
                    if (datum.label) {
                        tokens = tokens.concat(Bloodhound.tokenizers.whitespace(datum.label));
                    }
                    if (datum.label != datum.value) {
                        tokens.push('' + datum.value);
                    }
                    if (config.tokens) {
                        _.each(config.tokens, function (key) {
                            var val = datum[key];
                            if (!val) {
                                return;
                            } else if (_.isString(val)) {
                                tokens = tokens.concat(Bloodhound.tokenizers.whitespace(val));
                            } else if (_.isArray(val)) {
                                _.each(val, function (subVal) {
                                    tokens = tokens.concat(Bloodhound.tokenizers.whitespace(subVal));
                                });
                            }
                        });
                    }
                    return tokens;
                },
                identify: function (datum) {
                    return datum.value;
                }
            };

            var transform = function (data) {
                if (config.transform) {
                    data = getter(data, config.transform);
                }
                _.each(data, function (item) {
                    item.value = getter(item, config.value);
                    item.label = getter(item, config.label);
                });

                if (config.prefetch) {
                    if (config.prefetch.sort) {
                        data.sort(config.prefetch.sort);
                    }
                    _.each(data, function (item, i) {
                        item.i = i;
                    });
                }

                return data;
            };

            var url = urlHelper.resolveUrl(config.url);

            if (config.prefetch) {
                opts.prefetch = {
                    url: url,
                    cache: config.prefetch.cache === true,
                    cacheKey: config.prefetch.key,
                    transform: transform
                };
            } else {
                opts.remote = {
                    url: url,
                    wildcard: '{s}',
                    transform: transform
                };
            }

            return opts;
        }

        function delimit(before, value, after) {
            if (value === '' || value == null) {
                return '';
            } else {
                return (before == null ? '' : before) + value + (after == null ? '' : after);
            }
        }

        function getIndex(type) {
            var deferred = $.Deferred();

            var engine = get(type);

            engine.initialize()
                .done(function () {
                    deferred.resolveWith(this, [_.sortBy(engine.index.datums, 'i'), engine]);
                })
                .fail(function () {
                    deferred.rejectWith(this, arguments);
                });

            return deferred;
        }

        return {
            get: get,
            getIndex: getIndex
        };
    }());

    var dataSets = (function () {
        function boolLabel(prop, text, style, expected) {
            if (expected === undefined) {
                expected = true;
            }

            var cfg = {
                getter: function (d) {
                    return (d.hasOwnProperty(prop) && d[prop] === expected) ? (text ? text : prop) : null;
                }
            };

            if (style) {
                cfg.style = function (d) { return style; };
            }
            return cfg;
        }

        function getStatusStyle(status) {
            switch (status) {
                case 'Deleted':
                case 'Cancelled': return 'danger';
                case 'Expired':
                case 'Ended':
                case 'Prelisted': return 'warning';
                case 'Published': return 'success';
                default: return "secondary";
            }
        }

        var label = {
            archived: boolLabel('archived', 'archived', 'warning'),
            deactivated: boolLabel('active', 'disabled', 'warning', false),
            Deactivated: boolLabel('Active', 'disabled', 'warning', false),
            status: {
                getter: function (d) { return d.status ? d.status.toUpperCase() : null; },
                style: function (d) { return getStatusStyle(d.status); }
            },
            Status: {
                getter: function (d) { return d.Status ? d.Status.toUpperCase() : null; },
                style: function (d) { return getStatusStyle(d.Status); }
            }
        };

        function get(type) {
            var dataset = {
                display: 'label',
                name: type,
                source: engines.get(type).ttAdapter(),
                // Bug when using limit (better to use server-side limit anyway): https://github.com/twitter/typeahead.js/issues/1795
                // This means prefetched data isn't limited when searching, however prefetched data should always be small or it shouldn't be prefetched
                limit: Infinity,
                templates: {
                    pending: '<div class="tt-pending">searching...</div>',
                    notFound: '<div class="tt-notfound">no matches</div>'
                }
            };

            switch (type) {
                case 'Activity':
                    setTableTemplates(dataset, [
                        { name: 'Title', getter: 'label', span: 6, labels: [label.status] },
                        { name: 'Location', getter: 'location', span: 6 }
                    ]);
                    break;
                case 'ActivityType':
                    dataset.templates.suggestion = getLabelledSuggestion(label.archived);
                    break;
                case 'Event':
                    setTableTemplates(dataset, [
                        { name: 'Title', getter: 'label', span: 5, labels: [label.Status] },
                        { name: 'Date', getter: 'Start', span: 3 },
                        { name: 'Venue', getter: 'Venue', span: 4 }
                    ]);
                    break;
                case 'JobSeeker':
                    setTableTemplates(dataset, [
                        { name: 'Name', getter: function (datum) { return datum.FirstName + ' ' + datum.LastName; }, span: 5 },
                        { name: 'Student No.', getter: 'ExternalId', span: 3 },
                        { name: 'Email', getter: 'Email', span: 4 }
                    ]);
                    break;
                case 'EventType':
                    dataset.templates.suggestion = getLabelledSuggestion(label.archived);
                    break;
                case 'ExperienceType':
                    dataset.templates.suggestion = getLabelledSuggestion(label.archived);
                    break;
                case 'WorkGroup':
                    dataset.templates.suggestion = getLabelledSuggestion(
                        boolLabel('openToJobSeekers', 'open to students', 'warning'), // TODO: use strings
                        boolLabel('openToAdministrators', 'open to admin', 'warning'),
                        boolLabel('default', null, 'info', true)
                    );
                    break;
                case 'JounralLabel':
                case 'GeneralLabel':
                    dataset.templates.suggestion = getLabelledSuggestion(
                        boolLabel('archived', null, 'warning'),
                        boolLabel('private', null, 'info')
                    );
                    break;
                case 'Organisation':
                    setTableTemplates(dataset, [
                        { name: 'Name - Division', getter: 'label', span: 6, labels: [label.Deactivated] },
                        { name: 'Email', getter: 'Email', span: 6 }
                    ]);
                    break;
                case 'OrganisationContact':
                    setTableTemplates(dataset, [
                        { name: 'Contact', getter: 'label', span: 4 },
                        { name: 'Name - Division', getter: 'OrganisationName', span: 4, labels: [label.Deactivated] },
                        { name: 'Email', getter: 'Email', span: 4, labels: [label.Deactivated] }
                    ]);
                    break;
                case 'GuestTracker':
                    setTableTemplates(dataset, [
                        { name: 'Name', getter: 'label', span: 4 },
                        { name: 'Email', getter: 'Email', span: 4 },
                        { name: 'Type', getter: 'TypeDescription', span: 4, labels: [label.Deactivated] }
                    ]);
                    break;
                case 'Administrator':
                    setTableTemplates(dataset, [
                        { name: 'Name', getter: 'label', span: 4, xsSpan:12, labels: [label.Deactivated] },
                        { name: 'Email', getter: 'Email', span: 4, xsSpan: 12 },
                        { name: 'Position', getter: 'Position', span: 4, xsSpan: 12 }
                    ]);
                    break;
                case 'Developer':
                    setTableTemplates(dataset, [
                        { name: 'Developer ID', getter: 'Id', span: 4 },
                        { name: 'Name', getter: 'label', span: 2 },
                        { name: 'Email', getter: 'Email', span: 3 },
                        { name: 'Company', getter: 'Company', span: 3 }
                    ]);
                    break;
                case 'Campus':
                    dataset.templates.suggestion = getLabelledSuggestion(label.deactivated);
                    break;
                case 'CampusBuilding':
                    setTableTemplates(dataset, [
                        { name: 'Name', getter: 'label', span: 6, labels: [label.archived] },
                        { name: 'Campus', getter: 'campusName', span: 6 }
                    ]);
                    break;
                case 'OnCampusLocation':
                    setTableTemplates(dataset, [
                        { name: 'Name', getter: 'label', span: 4, labels: [label.archived] },                        
                        { name: 'Building', getter: 'buildingName', span: 4 },
                        { name: 'Campus', getter: 'campusName', span: 4 }
                    ]);
                    break;
                case 'Major':
                    setTableTemplates(dataset, [
                        { name: 'Name', getter: 'id', span: 12 }
                    ]);
                    break;
                case 'Skill':
                    setTableTemplates(dataset, [
                        { name: 'Name', getter: 'label', span: 6, labels: [label.archived] },
                        { name: 'Classification', getter: 'classification', span: 6 }
                    ]);
                    break;
                case 'ResourceTopic':
                    setTableTemplates(dataset, [
                        { name: 'Name', getter: 'label', span: 6, labels: [label.archived] },
                        { name: 'Promoted', getter: 'promoted', span: 6 }
                    ]);
                    break;
                case 'Endorsement':
                    setTableTemplates(dataset, [
                        { name: 'Name', getter: 'label', span: 6, labels: [label.archived] },
                        { name: 'Acronym', getter: 'acronym', span: 6 }
                    ]);
                    break;
                default:
                    dataset.templates.suggestion = defaultSuggestion;
                    break;
            }

            return dataset;
        }

        function setTableTemplates(dataset, config) {
            dataset.templates.header = getTableHeader(config);
            dataset.templates.suggestion = getTableSuggestion(config);
        }

        function getLabelledSuggestion() {
            var config = arguments;
            return function (datum) {
                return '<div>' + datum.label + '<br class="d-block d-sm-none" />' + getLabels(datum, config) + '</div>';
            };
        }

        function getTableHeader(config) {
            var spans = [];
            $.each(config, function (i, cfg) {
                spans.push('<div class="col-' + cfg.span + '">' + cfg.name + '</div>');
            });
            return '<div class="tt-header"><div class="row">' + spans.join('') + '</div></div>';
        }

        function getTableSuggestion(config) {
            return function (datum) {
                var spans = [];


                $.each(config, function (i, cfg) {
                    var text = getter(datum, cfg.getter);

                    var span = $('<div>')
                        .addClass('col-' + cfg.span)
                        .text(text ? text : '')
                        .append(' ' + getLabels(datum, cfg.labels));

                    spans.push(span[0].outerHTML);
                });

                return '<div><div class="row text-break">' + spans.join('') + '</div></div>';
            };
        }

        function getLabels(datum, config) {
            if (!config) return '';

            var labels = [];

            $.each(config, function (i, cfg) {
                var text = getter(datum, cfg.getter);

                if (text) {
                    var style = getter(datum, cfg.style);

                    var label = $('<span class="badge float-md-right mr-1" >')
                        .addClass('badge-' + (style ? style : 'secondary'))
                        .text(text);

                    labels.push(label[0].outerHTML);
                }
            });

            return labels.join(' ');
        }

        function defaultSuggestion(datum) {
            return $('<div>').text(datum.label);
        }

        return { get: get };
    }());

    function getter(item, prop) {
        return typeof prop === 'function' ? prop(item) : item[prop];
    }

    $.fn.chTypeahead = function (options) {
        var engine = engines.get(options.type);

        if (engine.prefetch) {
            this.on('focus', initializeEngine);
        }

        function initializeEngine(e) {
            engine.initialize();
            $(e.currentTarget).off('focus', initializeEngine);
        }

        if (options.submit) {
            this.on('typeahead:select', function () {
                var form = $(this.form);

                // timeout so typeahead-id executes first
                setTimeout(function () {
                    form.submit();
                });
            });
        }

        var response = this.typeahead({
            highlight: true,
            minLength: 1
        }, dataSets.get(options.type));

        this.closest('.twitter-typeahead').addClass('form-control');

        return response;
    };

    return {
        engines: engines,
        dataSets: dataSets
    };
}(jQuery, Bloodhound, _, urlHelper));
